module.exports = __webpack_public_path__ + "img/66.44110c62.jpg";